import Vue from 'vue'
import VueRouter from 'vue-router'
import dashboard from '@/views/dashboard.vue'
import translation from '@/components/translate.vue'
import login from '@/views/login.vue'
import { app } from '@/firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/index.html',
    name: 'indexhtml',
    component: dashboard
  },
  {
    path: '/',
    name: 'Dashboard',
    component: dashboard,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        name: 'translation',
        component: translation
      }
    ]
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from, next) =>{
  let currentUser = app.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login')
  else if (!requiresAuth && currentUser) next('/')
  else next()
})

export default router
